// removed by extract-text-webpack-plugin
module.exports = {"product-type":"product-type--3vvEZ","img":"img--2-87C","text":"text--3X66c","img-wrapper":"img-wrapper--iZyZM","inner":"inner--1YIi8","modal-trigger":"modal-trigger--inZ5C","modal-inner":"modal-inner---EwmI","close-wrapper":"close-wrapper--32roN","close":"close--1xJ0Q","image-wrapper":"image-wrapper--35VUs","full-img":"full-img--sMmyg"};


//////////////////
// WEBPACK FOOTER
// ./client/components/product-type/product-type.scss
// module id = 481
// module chunks = 0